import type { SubEvaluation } from '@/teoCore/TeoApi';
import type {
  MarkerPillData,
  MarkerPillPerspectiveData,
  MarkerPillType,
} from '@/ui/elements/tpi-drawer/dimensionCard/DimensionCard.svelte';
import type { PillGroup } from '@/ui/elements/tpi-drawer/TPIDrawer.svelte';

export function createPillGroupsFromIndices(indices: Record<string, SubEvaluation>): PillGroup[] {
  const pillGroups: PillGroup[] = [];

  let uniqueGroupId = 0;

  for (const iKey in indices) {
    const pills: (MarkerPillData | MarkerPillPerspectiveData)[] = [];
    const index = indices[iKey];

    if (index) {
      let uniquePillId = 0;

      for (const tpKey in index.text_properties) {
        const textProp = index.text_properties[tpKey];

        if (textProp) {
          const type: MarkerPillType =
            textProp.title.includes('(Sender/Empfänger)') ?
              'MarkerPillPerspectiveData'
            : 'MarkerPillData';
          const pill: MarkerPillData | MarkerPillPerspectiveData = {
            id: String(uniquePillId++),
            key: tpKey,
            type: type,
            label: type === 'MarkerPillData' ? textProp.title : undefined,
            value: type === 'MarkerPillData' ? textProp.num : undefined,
            labelSender: type === 'MarkerPillPerspectiveData' ? 'Sender' : undefined,
            labelReceiver: type === 'MarkerPillPerspectiveData' ? 'Empfänger' : undefined,
            valueSender:
              type === 'MarkerPillPerspectiveData' ?
                textProp.num === 0 ?
                  0
                : 100 - textProp.num
              : undefined,
            valueReceiver: type === 'MarkerPillPerspectiveData' ? textProp.num : undefined,
          };
          pills.push(pill);
        }
      }

      const pg: PillGroup = {
        id: String(uniqueGroupId++),
        key: iKey,
        label: index.title ?? 'unknown',
        used: index.used ?? false,
        score: index.score,
        pills: pills,
      };

      pillGroups.push(pg);
    }
  }

  return pillGroups;
}
